import Vector2 from "../../math/Vector2";
import Color from "../../util/Color";
import Explosion from "../Explosion";
import EmpBlast from "../SPAbilities/EmpBlast";
import SPBogey from "../SPBogey";
import SPBullet from "../SPBullet";
import SPGun from "../SPGun";
import SPPlayer from "../SPPlayer";

export default class ShockwaveLauncher extends SPGun {
    range = 128;

    constructor(player: SPPlayer) {
        super(player, {
            damage: 5,
            fireRate: 1,
            reloadTime: 10,
            bulletSpeed: 0,
            magSize: 1,
            mouseTrigger: 2,
            maxEnemiesHit: 1
        });
    }

    onShoot(): void {
        for (const bogey of this.player.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey)) {
            if (Vector2.distance(bogey.transform.position, this.player.transform.position) <= this.range + bogey.size) {
                bogey.Damage(this.damage);
            }
        }

        this.player.engine.NewGameObjectWithScript(Explosion, {
            position: this.player.transform.position,
            initialValues: {
                size: this.range,
                w: this.range * 2,
                color: new Color(80,255,80)
            }
        });
    }
}